import service from "@/store/services/service-centers-service";

export const state = () => ({
  list: {},
  serviceCenter: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, serviceCenter) => {
    state.serviceCenter = serviceCenter;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((serviceCenter) => {
      commit("SET_RESOURCE", serviceCenter);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((serviceCenter) => {
      commit("SET_RESOURCE", serviceCenter);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((serviceCenter) => {
      commit("SET_RESOURCE", serviceCenter);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  serviceCenter: (state) => state.serviceCenter,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((serviceCenter) => ({
      id: serviceCenter.id,
      name: `${serviceCenter.name}`,
    }));
  },
};

const serviceCenters = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default serviceCenters;
